import { render, staticRenderFns } from "./ArchivesModuleView.vue?vue&type=template&id=5afcd37e&scoped=true&"
import script from "./ArchivesModuleView.vue?vue&type=script&lang=js&"
export * from "./ArchivesModuleView.vue?vue&type=script&lang=js&"
import style0 from "./ArchivesModuleView.vue?vue&type=style&index=0&id=5afcd37e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afcd37e",
  null
  
)

export default component.exports